export type ColorEffectInput = {
  attribute: string;
  document: Document;
  value: string;
  variable: string;
};

export type ResetColorEffectInput = Omit<ColorEffectInput, "value">;

const styleSelector = 'style[data-migrosone-a11y-page-effects="color"]';

const colorEffectStyles = `
html[data-migrosone-a11y-color-effects] body > :not(#migrosone-a11y-widget-root) {
  filter: var(--migrosone-a11y-contrast-filter, ) var(--migrosone-a11y-blue-filter, ) var(--migrosone-a11y-grayscale-filter, );
}
`;

function canUseDocument(document: Document) {
  return Boolean(document.head && document.body && document.documentElement);
}

function ensureColorEffectStyle(document: Document) {
  const existing = document.querySelector(styleSelector);
  if (existing) {
    return true;
  }

  const style = document.createElement("style");
  style.setAttribute("data-migrosone-a11y-page-effects", "color");
  style.textContent = colorEffectStyles;
  document.head.appendChild(style);
  return true;
}

export function applyColorEffectValue({
  attribute,
  document,
  value,
  variable,
}: ColorEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  ensureColorEffectStyle(document);
  document.documentElement.style.setProperty(variable, value);
  document.documentElement.setAttribute(attribute, "true");
  document.documentElement.setAttribute("data-migrosone-a11y-color-effects", "true");
  return true;
}

export function resetColorEffectValue({
  attribute,
  document,
  variable,
}: ResetColorEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  document.documentElement.style.removeProperty(variable);
  document.documentElement.removeAttribute(attribute);
  return true;
}
